import * as i0 from "@angular/core";
var FuseSidebarService = /** @class */ (function () {
    function FuseSidebarService() {
        this.sidebarRegistry = {};
    }
    /**
     * Add the sidebar to the registry
     *
     * @param key - The key of the sidebar
     * @param sidebar - The sidebar component
     */
    FuseSidebarService.prototype.register = function (key, sidebar) {
        if (this.sidebarRegistry[key]) {
            console.error("The sidebar with the key '" + key + "' already exists. Either unregister it first or use a unique key.");
            return;
        }
        this.sidebarRegistry[key] = sidebar;
    };
    /**
     * Remove the sidebar from the registry
     *
     * @param key - The key of the sidebar
     */
    FuseSidebarService.prototype.unregister = function (key) {
        if (!this.sidebarRegistry[key]) {
            console.warn("The sidebar with the key '" + key + "' doesn't exist in the registry.");
        }
        delete this.sidebarRegistry[key];
    };
    /**
     * Return the sidebar with the given key
     *
     * @param key - The key of the sidebar
     */
    FuseSidebarService.prototype.getSidebar = function (key) {
        if (!this.sidebarRegistry[key]) {
            console.warn("The sidebar with the key '" + key + "' doesn't exist in the registry.");
            return;
        }
        return this.sidebarRegistry[key];
    };
    FuseSidebarService.prototype.closeAll = function () {
        for (var key in this.sidebarRegistry) {
            if (this.sidebarRegistry.hasOwnProperty(key)) {
                this.sidebarRegistry[key].close();
            }
        }
    };
    FuseSidebarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseSidebarService_Factory() { return new FuseSidebarService(); }, token: FuseSidebarService, providedIn: "root" });
    return FuseSidebarService;
}());
export { FuseSidebarService };
